<template>
    <input
        ref="input"
        type="text"
        inputmode="decimal"
        autocomplete="off"
        class="nota-input"
        :class="{ 'nota-input--erro': erro || invalido, 'nota-input--abaixo': abaixo, 'nota-input--conflito': conflito }"
        :value="texto"
        :disabled="disabled"
        :title="dica"
        :data-invalido="invalido ? 1 : 0"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @keydown="onKeydown"
        @dblclick="$emit('dblclick')"
    />
</template>

<script>
// Input de nota (média do bimestre): 0 a 10, até duas casas decimais, vírgula ou ponto.
// Emite número (ou '' quando vazio). Valor inválido fica marcado em vermelho e não é emitido.
function formatar (v) {
    if (v === '' || v === null || v === undefined) return ''
    const n = Number(v)
    if (isNaN(n)) return String(v)
    if (n === 10) return '10'
    const casas = Math.round(n * 100) % 10 === 0 ? 1 : 2
    return n.toFixed(casas).replace('.', ',')
}

export default {
    name: 'NotaInput',
    props: {
        value: { type: [Number, String], default: '' },
        disabled: { type: Boolean, default: false },
        erro: { type: Boolean, default: false },
        conflito: { type: Boolean, default: false },
        mediaMinima: { type: Number, default: 5 },
        dica: { type: String, default: '' }
    },
    data () {
        return { texto: formatar(this.value), focado: false, invalido: false }
    },
    computed: {
        abaixo () {
            const n = Number(String(this.texto).replace(',', '.'))
            return this.texto !== '' && !this.invalido && !isNaN(n) && n < this.mediaMinima
        }
    },
    watch: {
        value (v) {
            if (!this.focado) {
                this.texto = formatar(v)
                this.invalido = false
            }
        }
    },
    methods: {
        // Só aceita o que forma uma nota válida enquanto se digita: até 2 dígitos inteiros, uma vírgula
        // (ou ponto), até 2 casas decimais e valor máximo 10. Tecla que quebraria isso é desfeita na hora.
        onInput (e) {
            const v = String(e.target.value).replace(/[^\d.,]/g, '').replace('.', ',')
            const normal = v.replace(',', '.')
            const valido = v === '' || (/^\d{0,2}(,\d{0,2})?$/.test(v) && !(normal !== '' && normal !== '.' && Number(normal) > 10))

            if (!valido) {
                const pos = Math.max(0, (e.target.selectionStart || 1) - 1)
                e.target.value = this.texto
                e.target.setSelectionRange(pos, pos)
                return
            }

            this.texto = v
            e.target.value = v
            this.invalido = false

            if (v === '' || v === ',') {
                this.$emit('input', '')
                return
            }

            if (!v.endsWith(',')) {
                this.$emit('input', Math.round(Number(normal) * 100) / 100)
            }
        },
        onFocus (e) {
            this.focado = true
            e.target.select()
        },
        onBlur () {
            this.focado = false
            if (!this.invalido) this.texto = formatar(this.value)
        },
        onKeydown (e) {
            const mapa = { Enter: 'baixo', ArrowDown: 'baixo', ArrowUp: 'cima' }
            if (mapa[e.key]) {
                e.preventDefault()
                this.$emit('navegar', mapa[e.key])
            } else if (e.key === 'ArrowRight' && e.target.selectionStart === String(this.texto).length) {
                e.preventDefault()
                this.$emit('navegar', 'direita')
            } else if (e.key === 'ArrowLeft' && e.target.selectionStart === 0 && e.target.selectionEnd === 0) {
                e.preventDefault()
                this.$emit('navegar', 'esquerda')
            }
        },
        focus () {
            if (this.$refs.input) this.$refs.input.focus()
        }
    }
}
</script>

<style>
    .nota-input {
        width: 58px;
        height: 28px;
        text-align: center;
        border: 1px solid #1c69b3;
        border-radius: 4px;
        font-size: 13px;
        color: #303133;
        background: #fff;
        outline: none;
    }
    .nota-input:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, .25);
    }
    .nota-input:disabled {
        background: #f5f7fa;
        border-color: #dcdfe6;
        color: #606266;
    }
    .nota-input--abaixo {
        color: #f56c6c;
        font-weight: 600;
    }
    .nota-input--erro,
    .nota-input--erro:focus {
        border-color: #f56c6c;
        box-shadow: 0 0 0 2px rgba(245, 108, 108, .2);
    }
    .nota-input--conflito,
    .nota-input--conflito:focus {
        border-color: #e6a23c;
        box-shadow: 0 0 0 2px rgba(230, 162, 60, .25);
    }
</style>
